import { SET_REGISTERED_DIETITIAN, SET_MACRO_ANSWERS, SET_MACRO_RESULT } from "../actions/types";
const initState = {
    assigned_RD: "",
    has_contacted_RD: false,
    macroAnswers: null,
    macroResult: null,
};
export default function dietitianReducer(state = initState, action) {
    switch (action.type) {
        case SET_REGISTERED_DIETITIAN: {
            return {
                ...state,
                ...action.payload,
            };
        }
        case SET_MACRO_ANSWERS: {
            return {
                ...state,
                macroAnswers: action.payload,
            };
        }
        case SET_MACRO_RESULT: {
            return {
                ...state,
                macroResult: action.payload,
            };
        }
        default:
            return state;
    }
}
